export const statusMap = {
  onsale: {
    title: '上架中',
    color: '#4EB31C',
  },
  auditing: {
    title: '审核中',
    color: '#939393',
  },
  notonsale: {
    title: '下架中',
    color: '#000',
  },
  refuse: {
    title: '审核失败',
    color: '#D93347',
  },
  soldout: {
    title: '下架中',
    color: '#000',
  },
  atrepo: {
    title: '下架中',
    color: '#000',
  },
};

export const statusTab = [{
  index: 0,
  value: 'all',
  name: '全部宝贝',
},
{
  index: 1,
  value: 'onsale',
  name: '上架中的商品',
},
{
  index: 2,
  value: 'auditing',
  name: '审核中的商品',
},
{
  index: 3,
  value: 'notonsale',
  name: '下架商品',
},
{
  index: 4,
  value: 'refuse',
  name: '审核失败商品',
},
];

export const sourceList = [{
  name: '全部商品',
  value: 'all',
},
{
  name: '京东',
  value: 'jd',
},
{
  name: '企鹅小店',
  value: 'mk',
},
{
  name: '拼多多',
  value: 'pdd',
},
];

export const saasMap = {
  mk: {
    name: '企鹅小店',
    value: 'mk',
    type: 1,
  },
  jd: {
    name: '京东',
    value: 'jd',
    type: 2,
  },
  pdd: {
    name: '拼多多',
    value: 'pdd',
    type: 3,
  },
};

export const saasTypeMap = {
  1: '企鹅小店',
  2: '京东',
  3: '拼多多',
  401: '唯品会',
};

export const mediaList = [{
  name: '微视',
  value: 'ws',
},
{
  name: 'K歌',
  value: 'kg',
},
{
  name: '企鹅号',
  value: 'om',
},
{
  name: 'QQ',
  value: 'qq',
},
{
  name: '腾讯视频',
  value: 'txvideo',
},
{
  name: 'QQ小世界',
  value: 'qq_xsj',
},
{
  name: '看点APP',
  value: 'kd_app',
},
];

/**
 * 获取媒体配置 (全局统一媒体配置)
 * @param {Object} routeParam  路由参数
 */
export const getMedia = (routeParam) => {
  const map = {
    ws: {
      name: '微视',
      value: 'ws',
      type: 1,
      hasMaterialInfo: true, // 是否具有编辑素材能力
    },
    kg: {
      name: 'K歌',
      value: 'kg',
      type: 2,
      hasMaterialInfo: false,
    },
    om: {
      name: '企鹅号',
      value: 'om',
      type: 3,
      hasMaterialInfo: false,
    },
    qq: {
      name: 'QQ',
      value: 'qq',
      type: 4,
      hasMaterialInfo: false,
    },
    txvideo: {
      name: '腾讯视频',
      value: 'txvideo',
      type: 9,
      hasMaterialInfo: true,
    },
    kdlive: {
      name: '看点直播',
      value: 'kdlive',
      type: 10,
      hasMaterialInfo: false,
    },
    kd_app: {
      name: '看点APP',
      value: 'kd_app',
      type: 19,
      hasMaterialInfo: true,
    },
    qq_xsj: {
      name: 'QQ小世界',
      value: 'qq_xsj',
      type: 24,
      hasMaterialInfo: true,
    },
  };

  return map[routeParam] || {};
};

export const orderStatusMap = {
  0: '待支付',
  1: '已付款',
  2: '待收货',
  3: '已收货',
  4: '已退款',
  5: '已取消',
  6: '已完结',
  15: '拼团中',
  7: '无效',
};

export const productTypeMap = {
  0: '分销',
  1: '自营',
};

export const settlementStatusMap = {
  0: '未结算',
  1: '已结算',
};

// 提现的各种状态
export const withdrawStatusMap = {
  0: '提现中',
  1: '待付款',
  3: '付款成功',
  4: '付款失败',
};

export const withdrawComStatusMap = {
  1: '待付款',
  2: '待回寄发票',
  3: '付款成功',
  4: '付款失败',
};

// 提现疾苦的各种状态对应的文字颜色
export const withdrawStatusMapForColor = {
  0: 'status_ing',
  1: 'status_done',
  3: 'status_arrival',
  4: 'status_fail',
  2: 'status_fail',
};


export const saleStatistic = [{
  index: 0,
  value: 'viewers',
  name: '在线人数',
},
{
  index: 1,
  value: 'gifts',
  name: '送礼数',
},
{
  index: 2,
  value: 'addfans',
  name: '新增粉丝数',
},
{
  index: 3,
  value: 'orders',
  name: '下订单数',
},
];

export const STEP = {
  BOUTIQUE: 'BOUTIQUE', // 精品库
  COMMODITY_LINK: 'COMMODITY_LINK', // 添加商品链接
  ALL: 'ALL',
};

export const MESSAGE = {
  BOUTIQUE: '点击这里就可以进入精品库哦',
  COMMODITY_LINK: '点击这里添加京东/拼多多商品链接',
  ALL: '点击这里就可以看全部宝贝哦',
};

export const sassType = {
  1: '企鹅小店',
  2: '京东',
  3: '拼多多',
  4: '腾讯充值',
  5: '唯品会',
  6: '每日优鲜',
  7: '苏宁',
  8: '微拍堂',
  9: '思埠',
  14: '胖吴',
  2017: '京喜',
  2011: '有赞',
  401: '唯品会',
  2025: 'ams微店',
};

export const IDENTITY = {
  PERSONAL: 0, // 个人
  ENTERPRISE: 1, // 企业
};

export const OPERATOR_DESC = {
  batchDelete: '删除',
  batchUpdate: '更新',
  batchShow: '显示',
  batchHide: '隐藏',
  batchSetTop: '置顶',
  batchSync: '同步',
};

// 提示弹层的信息
export const OPERATOR_DESC_CONTENT = {
  batchDelete: {
    title: '删除橱窗中的商品',
    content: '商品删除后，所有内容中在售的商品也会一并删除',
  },
  batchUpdate: {
    title: '更新选中的商品',
    content: '更新选中的商品后，商品的图片、价格、优惠券等商品信息将更新',
    showNotice: true, // 是否显示不再提醒，如果设置好了不再提醒则指定时间内不再展示弹框
  },
};

// 批量操作对应的api接口 status 字段值
export const OPERATOR = {
  batchDelete: 'delete',
  batchUpdate: 'update',
  batchShow: 'show',
  batchHide: 'hide',
  batchSetTop: 'setTop',
  batchSync: 'sync',
};

// 不同媒体对应的操作类型
const BASE_OPERATOR_CONFIG = ['batchSetTop', 'batchUpdate', 'batchDelete', 'batchSync'];
export const OPERATOR_CONFIG = {
  ws: ['batchShow', 'batchHide'].concat(BASE_OPERATOR_CONFIG),
  kg: BASE_OPERATOR_CONFIG,
  om: ['batchShow', 'batchHide'].concat(BASE_OPERATOR_CONFIG),
  qq: BASE_OPERATOR_CONFIG,
  txvideo: ['batchShow', 'batchHide'].concat(BASE_OPERATOR_CONFIG),
  kdlive: [], // 看点直播，无法批量操作
  kd_app: ['batchShow', 'batchHide'].concat(BASE_OPERATOR_CONFIG),
  qq_xsj: ['batchShow', 'batchHide'].concat(BASE_OPERATOR_CONFIG),
};

export const OPERATOR_QQ_CONFIG = {
  default: {
    all: ['batchDelete', 'batchUpdate'],
    onsale: ['batchDelete', 'batchUpdate'],
    auditing: ['batchDelete'],
    notonsale: ['batchDelete', 'batchUpdate'],
    refuse: ['batchDelete', 'batchUpdate'],
  },
};

export const MEDIA_TYPE = {
  ws: 'ws',
  kg: 'kg',
  om: 'om',
  qq: 'qq',
  txvideo: 'txvideo',
};
export const ROLEMAP = {
  100: '管理员',
};
